import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

const COOKIE_KEY = 'iltg-cookie-consent';
const EXPIRY_MONTHS = 12;

function getConsentExpiry() {
  try {
    const stored = localStorage.getItem(COOKIE_KEY);
    if (!stored) return null;
    const { accepted, expiresAt } = JSON.parse(stored);
    if (Date.now() > expiresAt) {
      localStorage.removeItem(COOKIE_KEY);
      return null;
    }
    return accepted;
  } catch {
    return null;
  }
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    // Show banner only if no valid consent stored
    const consent = getConsentExpiry();
    if (consent === null) {
      // Small delay so it doesn't flash immediately on page load
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const saveConsent = (accepted) => {
    const expiresAt = Date.now() + EXPIRY_MONTHS * 30 * 24 * 60 * 60 * 1000;
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ accepted, expiresAt }));
  };

  const handleAccept = () => {
    saveConsent(true);
    setAnimateOut(true);
    setTimeout(() => setVisible(false), 350);
  };

  const handleDecline = () => {
    saveConsent(false);
    setAnimateOut(true);
    setTimeout(() => setVisible(false), 350);
  };

  if (!visible) return null;

  return (
    <div className={`cookie-banner${animateOut ? ' cookie-banner--out' : ''}`} role="dialog" aria-label="Cookie Consent">
      <div className="cookie-banner__inner">
        <div className="cookie-banner__icon">🍪</div>
        <div className="cookie-banner__content">
          <p className="cookie-banner__title">We use cookies</p>
          <p className="cookie-banner__text">
            We use cookies and similar technologies to improve your experience, analyze site traffic,
            and deliver personalized content. By clicking <strong>Accept</strong>, you consent to our
            use of cookies as described in our{' '}
            <Link to="/privacy-policy" className="cookie-banner__link">Privacy Policy</Link>.
            {' '}You can manage your preferences at any time.
          </p>
        </div>
        <div className="cookie-banner__actions">
          <button className="cookie-banner__btn cookie-banner__btn--accept" onClick={handleAccept}>
            Accept All
          </button>
          <button className="cookie-banner__btn cookie-banner__btn--decline" onClick={handleDecline}>
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}
